<div class="modal-header">
    <h4 class="modal-title" [innerHtml]="title"></h4>
</div>
<div class="modal-body" >
    <p [innerHtml]="message"></p>
    <textarea [(ngModel)]="additionalText" rows="5"></textarea>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="activeModal.close(additionalText)">{{yesButtonText ?? 'Yes'}}</button>
    <button type="button" class="btn btn-info" (click)="activeModal.dismiss('cancel')">{{noButtonText ?? 'No'}}</button>
</div>